import { formatSecondsToDurationLabel } from "@memorang/helpers/common";
import { useTranslation } from "react-i18next";
import { IconButton } from "react-native-paper";
import { buttonRoundnessMultiplier } from "../../constants";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import Button from "../Button";

type ActionRowProps = {
	durationSeconds: number;
	isPlaying: boolean;
	isInQueue: boolean;
	onPlayPress: () => void;
	onToggleQueue: () => void;
};

const ActionRow = ({
	durationSeconds,
	isPlaying,
	isInQueue,
	onPlayPress,
	onToggleQueue,
}: ActionRowProps) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			justifyContent="center"
			gap={12}
		>
			<Button
				mode="contained"
				icon={isPlaying ? "account-music" : "play"}
				onPress={onPlayPress}
				style={{ borderRadius: theme.roundness * buttonRoundnessMultiplier }}
				accessibilityLabel={
					isPlaying
						? t("podcast.detail.playing")
						: t("podcast.a11y.playEpisode", {
								duration: formatSecondsToDurationLabel(durationSeconds),
							})
				}
			>
				{isPlaying
					? t("podcast.detail.playing")
					: formatSecondsToDurationLabel(durationSeconds)}
			</Button>
			<IconButton
				mode="outlined"
				icon={isInQueue ? "playlist-check" : "playlist-plus"}
				size={20}
				onPress={onToggleQueue}
				iconColor={theme.colors.onSurfaceVariant}
				style={{
					width: 40,
					height: 40,
					margin: 0,
					borderRadius: theme.roundness * buttonRoundnessMultiplier,
					borderColor: theme.colors.outlineVariant,
				}}
				accessibilityLabel={
					isInQueue
						? t("podcast.a11y.removeFromQueue")
						: t("podcast.a11y.addToQueue")
				}
			/>
		</Box>
	);
};

export default ActionRow;
